import { useState, useEffect } from "react";
import { css } from "styled-components";
import { useMedia, useMount } from "react-use";

export const breakpoints = {
  desktopLarge: 1920,
  desktop: 1600,
  desktopSmall: 1440,
  tabletLandscape: 1200,
  tablet: 1024,
  phone: 700,
};

const setMedia =
  (size) =>
  (...args) => css`
    @media (max-width: ${size}px) {
      ${css(...args)}
    }
  `;

export const isClient = () => {
  if (typeof window !== "undefined") {
    return true;
  }

  return false;
};

const getMedia = (breakpoint) => () => {
  if (
    typeof navigator !== "undefined" &&
    window &&
    window.innerWidth <= breakpoints[breakpoint]
  ) {
    return true;
  }

  return false;
};

export const media = {
  desktopLarge: setMedia(breakpoints.desktopLarge),
  desktop: setMedia(breakpoints.desktop),
  desktopSmall: setMedia(breakpoints.desktopSmall),
  tabletLandscape: setMedia(breakpoints.tabletLandscape),
  tablet: setMedia(breakpoints.tablet),
  phone: setMedia(breakpoints.phone),
};

export const useBreakpoint = (breakpoint) => {
  const [active, setActive] = useState(false);
  const detectBreakPoint = useMedia(
    `(max-width: ${breakpoints[breakpoint]}px)`,
  );

  useMount(() => {
    setActive(detectBreakPoint);
  });

  useEffect(() => {
    setActive(detectBreakPoint);
  }, [detectBreakPoint]);

  return active;
};

export const getScrollableParent = (
  element: HTMLElement,
  classNameToCheck: string,
) => {
  let parent = element.parentElement;
  while (parent) {
    if (
      parent.scrollHeight > parent.clientHeight ||
      parent.classList.contains(classNameToCheck)
    ) {
      return parent;
    }
    parent = parent?.parentElement;
  }
  return null;
};

export const scrollIntoView = (
  scrollableParent: Element,
  menuWrapper: Element,
) => {
  const parentRect = scrollableParent.getBoundingClientRect();
  const menuRect = menuWrapper.getBoundingClientRect();
  const viewOffsetTop = parentRect.top;
  const elementOffsetTop = menuRect.top;
  const elementHeight = menuRect.height;
  const viewHeight = parentRect.height;

  const paddingGap = 20;
  const viewRequiredAdditionalScroll =
    elementOffsetTop - viewOffsetTop + elementHeight - viewHeight;

  if (viewRequiredAdditionalScroll <= 0) {
    return;
  }

  const isAndroid = /Android/i.test(navigator.userAgent);

  setTimeout(
    () => {
      scrollableParent.scrollTo({
        top:
          scrollableParent.scrollTop +
          viewRequiredAdditionalScroll +
          paddingGap,
        behavior: "smooth",
      });
    },
    isAndroid ? 1500 : 100,
  );
};
